
export const STATUS = {
  'BONIFICADO': 'BONIFICADO',
  'COBRADO': 'COBRADO',
  'DISPENSADO': 'DISPENSADO',
  'ESPERA': 'ESPERA',
  'ESTORNADO': 'ESTORNADO',
  'ESTORNO_PARCIAL': 'ESTORNO_PARCIAL',
  'PAGO': 'PAGO'
}

export const STATUS_LABELS = {
  [ STATUS.PAGO ]: 'Pago',
  [ STATUS.BONIFICADO ]: 'Bonificado',
  [ STATUS.ESPERA ]: 'Espera',
  [ STATUS.ESTORNADO ]: 'Estornado'
}

export const STATUS_PAGO = [ STATUS.COBRADO, STATUS.DISPENSADO, STATUS.ESTORNO_PARCIAL ]

export const getStatusPago = ( status ) => {
  if ( STATUS_PAGO.includes( status ) ) {
    return {
      'label': STATUS_LABELS[ STATUS.PAGO ],
      'status': STATUS.PAGO
    }
  }
}

export const STATUS_LIST = [
  {
    'codigo': STATUS.ESPERA,
    'value': STATUS.ESPERA,
    'visualizacao': STATUS_LABELS[ STATUS.ESPERA ]
  },
  {
    'codigo': STATUS.ESTORNADO,
    'value': STATUS.ESTORNADO,
    'visualizacao': STATUS_LABELS[ STATUS.ESTORNADO ]
  },
  {
    'codigo': STATUS.PAGO,
    'value': STATUS.PAGO,
    'visualizacao': STATUS_LABELS[ STATUS.PAGO ]
  }
]

export const LABELS_CONTENT = {
  'BAIXAR_NF': 'Baixar nota fiscal',
  'BAIXAR_NF_ITEM_EXTRA': 'Baixar nota fiscal do item extra',
  'CODIGO_RASTREAMENTO': 'Código de rastreamento',
  'DATA_PAGAMENTO': 'Data de pagamento',
  'ENDERECO': 'Endereço',
  'INFO_CAIXINHA': 'Informações da caixinha',
  'ITEM_EXTRA': 'Item Extra',
  'KIT_ENVIADO_POR': 'Empresa responsável pela entrega: ',
  'NUMERO_PEDIDO': 'Número do Pedido',
  'PAGAMENTO': 'Pagamento',
  'VALOR': 'Valor'
}

export const OPCOES_BAIXAR_NF = {
  'PDF': 'PDF',
  'XML': 'XML'
}

export const MEUS_KITS_TITULO = 'Meus kits'
